import { render, staticRenderFns } from "./AsiaLogoStamp.vue?vue&type=template&id=b373d04a&"
import script from "./AsiaLogoStamp.vue?vue&type=script&lang=js&"
export * from "./AsiaLogoStamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports